import { Injectable } from '@angular/core';
import { IsLoadingService } from '@service-work/is-loading';
import { BehaviorSubject } from 'rxjs';

import { SupportRestService } from '../api/rest/support-rest.service';
import { SupportRequestType } from '../enum/support-request-type.enum';
import { ContactUs } from '../model/contact-us';

@Injectable({
  providedIn: 'root',
})
export class SupportStoreService {
  private readonly _contactUsRequest = new BehaviorSubject<ContactUs | null>(null);
  readonly contactUsRequest$ = this._contactUsRequest.asObservable();

  private readonly _categories = new BehaviorSubject<string[] | null>(null);
  readonly categories$ = this._categories.asObservable();

  private readonly _businessGroups = new BehaviorSubject<string[] | null>(null);
  readonly businessGroups$ = this._businessGroups.asObservable();

  constructor(private supportRest: SupportRestService, private isLoadingService: IsLoadingService) {}

  get categories(): string[] | null {
    return this._categories.value;
  }

  get businessGroups(): string[] | null {
    return this._businessGroups.value;
  }

  contactUs(contactRequest: ContactUs): void {
    this.isLoadingService.add(
      this.supportRest.contactUs(contactRequest).subscribe(() => {
        this._contactUsRequest.next(contactRequest);
      })
    );
  }

  getCategories(): void {
    if (this.categories) {
      return;
    }

    this.isLoadingService.add(
      this.supportRest.getSubjects().subscribe((subjects) => {
        this._categories.next(subjects);
      })
    );
  }

  sendSupportRequest(type: SupportRequestType, data: any): Promise<boolean> {
    return new Promise((resolve) => {
      this.isLoadingService.add(
        this.supportRest.sendSupportRequest(type, data).subscribe({
          next: () => {
            resolve(true);
          },
          error: () => resolve(false),
        })
      );
    });
  }

  getBusinessGroups(): void {
    if (this.businessGroups) {
      return;
    }

    this.isLoadingService.add(
      this.supportRest.getBusinessGroups().subscribe((businessGroups) => {
        this._businessGroups.next(businessGroups);
      })
    );
  }
}
